export const sizes: string[] = ["Small", "Large"];
